module.exports = __webpack_public_path__ + "img/thumb-002.83e2ce1a.png";